export default "__VITE_ASSET__2644b6e2__"